// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 6464 ? "search" : chunkId) + "_" + __webpack_require__.h().slice(0, 6) + ".js";
};